import { createContext, type Ref, use } from "react";
import type { StrictOmit } from "ts-essentials";
import type { MapsProps, MapsRef } from "./types";

type MapsContextValue = {
    mapsRootNode: HTMLDivElement;
    mapsProps: MapsProps;
    mapsRef: Ref<MapsRef> | undefined;
};

export const MapsContext = createContext<MapsContextValue | undefined>(
    undefined,
);

type UseMapsReturn = {
    mapsRootNode: MapsContextValue["mapsRootNode"];
    // "onEvent" and "onTrackingEvent" are excluded because we should use useSendEvent() or useSaveTrackingEvent() hooks instead
    mapsProps: StrictOmit<
        MapsContextValue["mapsProps"],
        "onEvent" | "onTrackingEvent"
    >;
    mapsRef: MapsContextValue["mapsRef"];
};

export function useMaps(): UseMapsReturn {
    const contextValue = use(MapsContext);

    if (contextValue === undefined) {
        throw new Error(
            "useMaps() was called before MapsContext value was properly initialized.",
        );
    }

    return contextValue;
}
